export const languages = [
    {
        id: 2,
        name: "English",
        code: "en",
    },
    {
        id: 1,
        name: "Español",
        code: "es",
    },
    {
        id: 3,
        name: "Português",
        code: "pt",
    },
];
